import React from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import ModalLayout from "@View/components/ModalLayout";
import DefaultInput from "@View/components/formInputs/DefaultInput";
import { CopyIcon } from "@View/components/svgComponents/CopyIcon";
import { formatDate } from "@Localization/utils";

const LeadTransferDetailsModal = ({ transfer, open, handleClose }) => {
  const { t } = useTranslation();

  const referralLink = transfer?.externalReceiverUrl;

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(referralLink)
      .catch((e) => console.error("[LeadTransferDetailsModal.copyReferralLink]", e));
  };

  if (!transfer) return null;

  return (
    <ModalLayout
      open={open}
      onClose={handleClose}
      title="h1.Transfer Details"
      subtitle={transfer.leadReceiverCustomerName}
    >
      <DefaultInput
        label="inputs.LeadReceiver"
        value={transfer.leadReceiverCustomerName || "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.CreditProduct"
        value={transfer.creditProduct || "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.RequestedAmount"
        value={transfer.requestedAmount != null ? String(transfer.requestedAmount) : "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.TermMonths"
        value={transfer.requestedTermMonths != null ? String(transfer.requestedTermMonths) : "—"}
        onChange={() => null}
      />
      {referralLink && (
        <FormControl className={"PassInput"}>
          <InputLabel htmlFor="lead-transfer-referral-link">
            {t("inputs.ReferralLink")}
          </InputLabel>
          <Input
            id="lead-transfer-referral-link"
            type={"text"}
            value={referralLink}
            onChange={() => null}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={handleCopyLink} onMouseDown={null}>
                  <CopyIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      )}
      <DefaultInput
        label="inputs.Status"
        value={transfer.status ? t(`LeadTransferStatus.${transfer.status}`) : ""}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.Create Date"
        value={transfer.createdAt ? formatDate(transfer.createdAt) : "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.BankDecisionAt"
        value={transfer.bankDecisionAt ? formatDate(transfer.bankDecisionAt) : "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.CreditIssuedAt"
        value={transfer.creditIssuedAt ? formatDate(transfer.creditIssuedAt) : "—"}
        onChange={() => null}
      />
      <DefaultInput
        label="inputs.BankComment"
        value={transfer.bankComment || "—"}
        onChange={() => null}
      />
    </ModalLayout>
  );
};

export default LeadTransferDetailsModal;
